<fgb-banner [pageTitle]="'contact.us.page.title'"></fgb-banner>

<fgb-page-header [showBalance]="false" [pageTitle]="'contact.us.page.title'" [backButtonLink]="'/'" />
<div class="container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
</div>
<fgbcl-contact-us></fgbcl-contact-us>
